import { render } from "./TeamCity.vue?vue&type=template&id=63894d03"
import script from "./TeamCity.vue?vue&type=script&lang=js"
export * from "./TeamCity.vue?vue&type=script&lang=js"
script.render = render

export default script